import e, { forwardRef as i } from "react";
import { Chip as o, Avatar as l } from "@mui/material";
import { I as r } from "./chunk.zlc_6vey.js";
import { g as c } from "./chunk.BurCwd5X.js";
const b = i(
  (a, t) => {
    const n = {
      variant: a.iconVariant,
      icon: a.icon
    };
    return /* @__PURE__ */ e.createElement(
      o,
      {
        id: a.id,
        disabled: a.disabled,
        label: a.label,
        onDelete: a.onDelete,
        variant: a.variant,
        avatar: a.avatar ? /* @__PURE__ */ e.createElement(l, { src: a.avatar, alt: "avatar" }) : void 0,
        icon: a.icon ? /* @__PURE__ */ e.createElement(r, { ...n, disabled: a.disabled }) : void 0,
        ref: t,
        onBlur: a.onBlur,
        onFocus: a.onFocus,
        onMouseOver: a.onMouseOver,
        onMouseLeave: a.onMouseLeave,
        ...c(t)
      }
    );
  }
);
export {
  b as I
};
